import { lazy } from 'react'

const AllGames = lazy(() => import('./AllGames'))
const Casino = lazy(() => import('./Casino'))
// const Virtual = lazy(() => import('./Virtual'))
// const Bingo = lazy(() => import('./Bingo'))
const Search = lazy(() => import('./Search'))
const Jackpot = lazy(() => import('./Jackpots'))
const Promotions = lazy(() => import('./Promotions'))
const Providers = lazy(() => import('./Providers'))
const Tournaments = lazy(() => import('./Tournaments'))

export const HomeRouters = [
  {
    index: true,
    element: <Casino />,
  },
  {
    path: 'all-games/:category?',
    element: <AllGames />,
  },
  {
    path: 'providers/:provider?',
    element: <Providers />,
  },
  {
    path: 'search',
    element: <Search />,
  },
  // {
  //   path: 'virtual',
  //   element: <Virtual />,
  // },
  // {
  //   path: 'bingo',
  //   element: <Bingo />,
  // },
  {
    path: 'tournaments',
    element: <Tournaments />,
  },
  {
    path: 'jackpots/:id?/:type?',
    element: <Jackpot />,
  },
  {
    path: 'promotions',
    element: <Promotions />,
  },
]
